import React from "react";
import { Phone } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function ArcadiaFreeInspectionCta() {
  return <section id="arcadia-free-inspection-cta" className="bg-foreground text-background py-16 md:py-24">
      <div className="container mx-auto px-4 md:px-6 flex flex-col items-center text-center">
        <h2 className="font-default text-3xl md:text-4xl lg:text-5xl font-bold mb-8 max-w-4xl leading-tight">
          Expert Pest Protection for Arcadia Homes & Ranches
        </h2>
        
        <div className="flex flex-col sm:flex-row items-center justify-center gap-6 sm:gap-8 mt-4">
          <div className="flex items-center gap-3 text-xl md:text-2xl font-semibold">
            <div className="bg-accent/20 p-3 rounded-full">
              <Phone className="size-6 md:size-7 text-accent" />
            </div>
            <div className="flex flex-col items-start">
              <span className="text-sm uppercase tracking-wider opacity-80">Same-Week Service Available</span>
              <span>Call Our Rural Property Experts</span>
            </div>
          </div>
          
          <Button asChild size="lg" className="bg-background text-foreground hover:bg-background/90 font-bold text-lg px-8 h-14 rounded-md shadow-lg">
            <Link to="/ContactPage">
              Claim Your Free Inspection
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}